export default {
    shippingOrders: [],
    shippingOrdersLoading: false,
    shippingOrderStatuses: [],
    shippingOrdersForShippingLabels: [],
    shippingOrdersForShippingLabelsLoading: false,
    shippingOrdersFilters: setInitialShipmentsOrdersFilters(),
    setInitialShipmentsOrdersFilters: setInitialShipmentsOrdersFilters
}

function setInitialShipmentsOrdersFilters() {
    return {
        status_id: 10, //Nowe
        number: null,
        orderCreatedAt__gte: null,
        orderCreatedAt__lte: null,
        shippingDate__gte: null,
        shippingDate__lte: null,
        createdBy_id: null,
    }
}
